import React, {useState, useEffect, useMemo} from 'react'
import {Node, useReactFlow} from 'reactflow'
import {AUTOMATION_AUDIENCE_OPTIONS} from '../../../../../../Utils/Constant/FlowConstants'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {useI18n} from '../../../../../../Utils/_helpers/useI18n'
import CreatableSelect from 'react-select/creatable'
import {MenuListProps, components} from 'react-select'
import {useGetAllSegmentsQuery} from '../../../../../../../services/cellcast'
import './TriggerSidebar.scss'

import {useDispatch, useSelector} from 'react-redux'
import {confirm} from 'react-confirm-box'
import {getalltagsdata, CreateData} from '../../../../Contacts/Tags/TagSlice/TagsSlices'
import TagPopupModal from '../../../../Contacts/AllContactsList/Modal/TagPopupModal'
import Select from 'react-select'

const optionsWithLabelChange = {
  closeOnOverlayClick: false,
  labels: {
    confirmable: 'Confirm',
    cancellable: 'Cancel',
  },
}

const TriggerSidebar: React.FC<{node: Node}> = ({node}) => {
  const {setNodes} = useReactFlow()
  const dispatch = useDispatch()
  const [openTagPopup, setOpenTagPopup] = useState(false)
  const [selectedAudience, setSelectedAudience] = useState<string>(
    node.data?.metaData?.trigger || AUTOMATION_AUDIENCE_OPTIONS[0].value
  )
  const [tag, setTag] = useState<any>([])
  const [selectedTags, setSelectedTags] = useState<any[]>(node.data?.metaData?.tags || [])
  const pathIcon = toAbsoluteUrl('/media/svg/automation/trigger.svg')
  const {t} = useI18n()

  useEffect(() => {
    dispatch(getalltagsdata())
  }, [])

  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  useEffect(() => {
    const filteredTags = tagslist?.filter((val: any) => {
      if (val?.type) {
        return val?.isHidden === false && val?.type !== 'list'
      }
      return val?.isHidden === false
    })
    let listData = filteredTags?.map((val: any) => ({value: val?._id, label: val?.name}))
    setTag(listData)
  }, [tagslist])

  const handleCreate = async (e: any) => {
    let confirNew = await confirm(
      'Are you sure you want to create a new tag?',
      optionsWithLabelChange
    )
    setSelectedTags([...selectedTags, {value: e, label: e}])
    confirNew &&
      dispatch(
        CreateData({
          name: e,
        })
      )
  }

  const handleTagsChange = (e: any) => {
    setSelectedTags(e)
  }

  const MenuList = (props: MenuListProps<any>) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <div
          style={{
            width: '100%',
            display: 'flex',
            gap: '6px',
            cursor: 'pointer',
            alignItems: 'center',
            justifyContent: 'center',
            borderTop: '1px solid #F4F5F7',
            paddingTop: '10px',
          }}
          onClick={() => {
            setOpenTagPopup(true)
          }}
        >
          <i
            style={{
              color: '#7950F2',
              fontWeight: 'bold !important',
            }}
            className='bi bi-plus-lg'
          ></i>
          <p
            style={{
              color: '#7950F2',
              margin: 0,
              fontWeight: 600,
            }}
          >
            Create new
          </p>
        </div>
      </components.MenuList>
    )
  }

  const {
    data: segmentsResponse,
    isLoading: segmentsLoading,
    isFetching: segmentsFetching,
  } = useGetAllSegmentsQuery({})
  const [selectedSegments, setSelectedSegments] = useState<any[]>(
    node.data?.metaData?.segments || []
  )
  const segmentOptions = segmentsResponse?.data
    ? segmentsResponse.data.map((segment: any) => ({
        value: segment._id,
        label: segment.name,
      }))
    : []

  useEffect(() => {
    setSelectedAudience(node.data?.metaData?.trigger || AUTOMATION_AUDIENCE_OPTIONS[0].value)
    setSelectedTags(node.data?.metaData?.tags || [])
    setSelectedSegments(node.data?.metaData?.segments || [])
  }, [node.id])

  useEffect(() => {
    setNodes((nds) =>
      nds.map((n) =>
        n.id === node.id
          ? {
              ...n,
              data: {
                ...n.data,
                metaData: {
                  ...n.data?.metaData,
                  trigger: selectedAudience,
                  tags: selectedTags,
                  segments: selectedSegments,
                },
              },
            }
          : n
      )
    )
  }, [selectedAudience, selectedTags, selectedSegments, node.id, setNodes])

  const AddTagPopup = useMemo(
    () => (
      <TagPopupModal
        selectedTag={selectedTags}
        setSelectedTag={setSelectedTags}
        show={openTagPopup}
        handleClose={() => setOpenTagPopup(false)}
      />
    ),
    [openTagPopup, selectedTags]
  )

  const handleAudienceClick = (audienceValue: string) => {
    setSelectedAudience(audienceValue)
  }

  return (
    <div className='p-4'>
      <div className='d-flex align-items-center gap-3 mb-4'>
        <div
          className='automation-icon-container'
          style={{
            backgroundColor: 'var(--bs-gray-dark)',
          }}
        >
          <img src={pathIcon} alt='trigger' className='automation-icon' />
        </div>
        <h3>{t('FLOW.NODE.TRIGGER')}</h3>
        <i
          className='bi bi-info-circle ms-1 info'
          title={t('FLOW.SIDEBAR.TRIGGER.MORE_INFO')}
          tabIndex={0}
          aria-label={t('FLOW.SIDEBAR.TRIGGER.MORE_INFO')}
        ></i>
      </div>

      <div className='d-flex flex-column gap-3 mt-4'>
        {AUTOMATION_AUDIENCE_OPTIONS.map((opt) => (
          <React.Fragment key={opt.key}>
            <div
              className={`automation-audience-card d-flex align-items-center gap-3 card border ${
                selectedAudience === opt.value ? 'border-primary selected' : ''
              } shadow-sm cursor-pointer mb-2 rounded-3`}
              onClick={() => handleAudienceClick(opt.value)}
              style={{position: 'relative'}}
            >
              <div className='d-flex align-items-center gap-3 p-3 w-100'>
                <div className='icon d-flex align-self-start mt-1'>
                  <i className={`bi ${opt.icon} fs-4`}></i>
                </div>
                <div>
                  <div className='title fw-bolder mb-1'>{t(opt.titleKey)}</div>
                  <div className='desc text-muted small'>{t(opt.descKey)}</div>
                </div>
              </div>
            </div>

            {selectedAudience === 'added_tag' && opt.value === 'added_tag' && (
              <div className='trigger-sidebar-dropdown'>
                <label className='form-label fw-bold'>Tag name</label>
                <CreatableSelect
                  value={selectedTags}
                  components={{MenuList}}
                  className='react-tags-selectbox common-select z-1000'
                  options={tag}
                  onChange={handleTagsChange}
                  onCreateOption={handleCreate}
                  isClearable={true}
                  isLoading={false}
                  isMulti={true}
                  styles={{
                    control: (base: Record<string, any>) => ({
                      ...base,
                      backgroundColor: 'var(--bs-gray-200) !important',
                      borderColor: base.borderColor,
                      boxShadow: base.boxShadow,
                      minHeight: 32,
                    }),
                    valueContainer: (base: any) => ({...base, paddingTop: 2, paddingBottom: 2}),
                    indicatorsContainer: (base: any) => ({
                      ...base,
                      paddingTop: 2,
                      paddingBottom: 2,
                    }),
                  }}
                  menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
                  closeMenuOnScroll={false}
                  menuShouldBlockScroll={true}
                />
                {AddTagPopup}
              </div>
            )}

            {selectedAudience === 'added_segment' && opt.value === 'added_segment' && (
              <div className='trigger-sidebar-dropdown'>
                <label className='form-label fw-bold'>Segments</label>
                <Select
                  isMulti
                  options={segmentOptions}
                  value={selectedSegments}
                  onChange={(newValue) =>
                    setSelectedSegments(Array.isArray(newValue) ? [...newValue] : [])
                  }
                  isLoading={segmentsLoading || segmentsFetching}
                  className='react-segments-selectbox common-select z-1000 w-80'
                  styles={{
                    control: (base) => ({
                      ...base,
                      backgroundColor: 'var(--bs-gray-200) !important',
                      borderColor: base.borderColor,
                      boxShadow: base.boxShadow,
                      minHeight: 32,
                    }),
                    valueContainer: (base) => ({...base, paddingTop: 2, paddingBottom: 2}),
                    indicatorsContainer: (base) => ({...base, paddingTop: 2, paddingBottom: 2}),
                  }}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default TriggerSidebar
